import React, {Component} from 'react';
//import {Link} from "react-router-dom";
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
//import {confirmAlert} from 'react-confirm-alert';
import ReactTooltip from 'react-tooltip';
//import pending from "../assets/img/pending.png";
//import approve from "../assets/img/approve.png";
//import reject from "../assets/img/reject.png";
//import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import jwt_decode from "jwt-decode";
import { Button } from 'reactstrap';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class MappedView extends Component {
    constructor(props){
        super(props);
        this.state = {
            isSubmit: false,
            loading: false,
            file_id: null,
            mapped_files : [],
            mappedData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: '',
               
            },
            mappedModel: false,
            data:[],
            raw_display_data: [],
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            relationData: [{ tables:"", columnLists:"", columns:"", id:"", relationToTables:"", toTables:"", toColumnLists:"", toColumns:"" }],
            deleteKeys:[],
            changedItems:[]
        }

    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        //this._getVersions();
        console.log(this.props.match.params);
        this._refreshMapped_View();
        this.setState({ 
            _notificationSystem: this.refs.notificationSystem,
            file_id: this.props.match.params.id       
        });
        //var _notificationSystem = this.refs.notificationSystem;
    }

    mappedData(id, user_id, file_name, file_path, timestamp, version, cur_version, status, user_type) {
        this.setState({
            mappedData: {
                id,
                user_id,
                file_name,
                file_path,
                timestamp,
                version,
                cur_version,
                status,
                user_type
            },
            mappedModel: !this.state.mappedModel
            //login_type:loginType
        });
        this._RawData(user_id, file_name, timestamp)
        //this.findGroups(userType);
        //this.findAccessKeys(id);
    }


    togglemappedModel() {
        this.setState({
            mappedModel: !this.state.mappedModel
        })
    }

    _refreshMapped_View() {
        if ($.fn.DataTable.isDataTable('#mappedViewTable')) {
            $('#mappedViewTable').DataTable().destroy();
        }
        axios.get(config.get('API_URL') + '/brandemi/view_mapped_data',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                file_id: this.props.match.params.id
            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                raw_display_data: response.data
            });
            $('#mappedViewTable').DataTable();
            this.setState({
                loading: false
            });
            //this.preAppender();

        });
    }

    handleChange(id, e) {
        console.log(id);
        console.log(e.target.value);
        this.setState({
            changedItems: {...this.state.changedItems, [id]:e.target.value},
            isChange: true
        });
    }

    sendBack = () => {
        console.log("Hello World");
        // const yourFunction = async () => {
        //     await new Promise(resolve => setTimeout(resolve, 1)); // 3 sec
        //     console.log("Waited 0s");
        //     this.props.history.push('/admin/master-data');
        // };
        // yourFunction();
    }

    mappingHandler = () => {
        this.setState({
            isSubmit: true,
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('file_id', this.state.file_id);
        data.append('userID', decoded._id);
        data.append('mappings', JSON.stringify(this.state.changedItems));
        data.append('userGroup', decoded.userGroup);
        console.log(data);
        axios.post(config.get('API_URL') + "/brandemi/map_data", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                console.log(res);
                if(res.data.success){
                    this.handleNotificationClick("tr", 1, res.data.success);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                    
                } 
                else {
                    this.handleNotificationClick("tr", 3, res.data.error);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })
        };

    render() {
        console.log(this.state.changedItems);    
        //console.log(this.state.relationData);
        /*let versions = this.state.versions.map((version,index) => {
            return (
                <option value={version.id} key={index+1}>{version.name}</option>
            )
        });*/

        let mapped_data = this.state.raw_display_data.map((value,index) => {
            return (
                    <tr key={index + 1}>
                    <td>{index+1}</td>
                    <td>{value.brand}</td>
                    <td>{value.category}</td>
                    <td>{value.description}</td>
                    <td>{value.sku}</td>
                    <td>{value.product_code}</td>
                    <td>{value.mrp}</td>
                    <td>{value.mop}</td>
                </tr>
            )
        });

        return(
            <div className="card-query-builder">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className="content">
                    <div className='sweet-loading'>
                        <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Button color="primary" onClick={this.sendBack.bind(this)}>Go Back</Button>{' '}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="content table-full-width table-responsive">
                                <table className="table table-striped table-hover" id="mappedViewTable">
                                    <thead>
                                        <tr>
                                            <th>Sr No.</th>
                                            <th>Brand</th>
                                            <th>Category</th>
                                            <th>Description</th>
                                            <th>SKU</th>
                                            <th>Product Code</th>
                                            <th>MRP</th>
                                            <th>MOP</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {mapped_data}
                                    </tbody>
                                </table>            
                            </div>
                        </div>
                    </div>
                    <div className="footer">
                        {/*<Link className="viewButton" data-tip="View"  ><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>*/}
                        <div className="stats"><i></i></div>
                    </div>
                </div>
            </div>
        );
    }
}
export default MappedView;